import { LitElement, html, css } from 'lit';
import { property, customElement, query } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

import { authenticatedAPICall } from '../../client/api-client';
import { PickupOrderStatusRemoved, formatDate } from '../../util/util';
import '../../elements/pickup-order/pickup-order';

import { PickupOrder, PickupSubOrder, Product } from '../../types/types';

type PickupOrderList = PickupOrder[];

@customElement('langhout-beton-order-cleanup-done')
export class LanghoutBetonOrderCleanupDone extends LitElement {
  static styles = css`
    input {
      padding: 7px;
      border-radius: 5px;
      font-size: 16px;
    }
  `;

  private limit = 100;
  private offset = 0;

  @property({ type: Array })
  private pickupOrders: PickupOrderList = [];

  @query('#showDate')
  private showDate?: HTMLInputElement;

  private selectedDate = '';

  constructor() {
    super();
    this.listPickupOrders();
    document.addEventListener(
      'refresh-tasks',
      this.refreshTaskListener as EventListener,
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(
      'refresh-tasks',
      this.refreshTaskListener as EventListener,
    );
  }

  refreshTaskListener = () => {
    this.listPickupOrders();
  };

  render() {
    if (this.pickupOrders.length === 0) {
      return html`
        <input
          type="date"
          id="showDate"
          name="showDate"
          value="${this.selectedDate}"
          @change="${() => {
            this.listPickupOrders();
          }}"
        />
        <h2>Er zijn geen orders opgeruimd ${this.getDateText()}</h2>
      `;
    }
    return html`
      <input
        type="date"
        id="showDate"
        name="showDate"
        value="${this.selectedDate}"
        @change="${() => {
          this.listPickupOrders();
        }}"
      />
      <h2>Opgeruimd ${this.getDateText()}</h2>
      <h3>Tonnage: ${this.getTotalWeight()}</h3>
      ${repeat(
        this.pickupOrders,
        pickupOrder => pickupOrder.id,
        pickupOrder => {
          return html`
            <pickup-order
              displayOnly
              .pickupOrder="${pickupOrder}"
            ></pickup-order>
          `;
        },
      )}
    `;
  }

  getDateText = () => {
    if (this.selectedDate !== '') {
      return `voor ${formatDate(this.selectedDate)}`;
    }
    return '';
  };

  listPickupOrders = async () => {
    let path = `/pickuporders/tasks?limit=${this.limit}&offset=${this.offset}&order_by=cleanup_time&states=${PickupOrderStatusRemoved}&view=true`;
    const showDateInputValue = this.showDate ? this.showDate.value : '';
    this.selectedDate = showDateInputValue;
    if (showDateInputValue != '') {
      const formattedDate = formatDate(showDateInputValue);
      path += `&cleanup_date=${formattedDate}`;
    }

    const result = await authenticatedAPICall(path, 'GET', new Headers());
    if (result.statusCode !== undefined && result.statusCode >= 200 && result.statusCode < 300 && Array.isArray(result.body)) {
      this.pickupOrders = result.body as PickupOrderList;
    }
  };

  getTotalWeight = () => {
    let totalWeight = 0;
    this.pickupOrders.forEach((pickupOrder: PickupOrder) => {
      pickupOrder.sub_orders.forEach((p: PickupSubOrder) => {
        p.products.forEach((p: Product) => {
          totalWeight += p.amount * p.weight;
        });
      });
    });
    totalWeight = Math.round(totalWeight);

    return `${totalWeight.toLocaleString('nl-NL')} kg`;
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'langhout-beton-order-cleanup-done': LanghoutBetonOrderCleanupDone;
  }
}
